<template>
  <!-- <div
    style="position:sticky;border: 1px solid #0000001A"
    :style="{ 'border-radius': `0 0 0 0`, 'font-family': GlobalFont, 'background-color': editTMP.isSecundary ? BGColorSecundary : BGColor, 'color': editTMP.isSecundary ? ColorSecundary : Color }"
  > -->
  <div
    style="position:sticky;border: 1px solid #0000001A"
    :style="{ 'border-radius': `0 0 0 0`, 'font-family': GlobalFont, 'background-color': editTMP.isSecundary ? BGColorSecundary : BGColor, 'color': editTMP.isSecundary ? ColorSecundary : Color }"
  >
    <v-layout
      wrap
      align-center
      justify-center
      style="position: relative; height: 100%;width: 100%;"
    >
      <v-flex xs12>
        <div
          class="text-center"
          :style="{ 
            'padding': !editTMP.isSecundary ? '20px 10px 20px 10px !important' : '10px 40px 10px 40px !important',
            'font-family':  editTMP.isSecundary ? FontSecundary : Font,
            'font-size': editTMP.isSecundary ? `${FontSizeSecundary}px` : `${FontSize}px`,
            'background-image': ((editTMP.isSecundary && withGradientSubmenu) || (!editTMP.isSecundary && withGradient)) ? 'linear-gradient(to top, rgba(128, 128, 128, 0.0), rgba(0, 0, 0, 0.2))' : '',
            }"
        >
          {{ edittmpName }}
        </div>
        <v-tooltip left> 
          <template v-slot:activator="{ on }">
            <div v-if="showEdits" style="position:absolute;top: 0px; left: 0px;height:100%;"
              v-on="editTMP.isNew ? on : null"
            >
              <!-- <v-btn
                class="mnuEdit"
                fab small text
                :dark="!editTMP.isNew"
                :disabled="editTMP.isNew"
                :color="enterpriseColor"
                style="margin-top: 10px;margin-left: 15px;"
              > -->
                <v-icon
                  style="font-size: 16px;margin-top: 10px;margin-left: 15px;"
                >mdi-cursor-move</v-icon>
              <!-- </v-btn> -->
            </div>
            <div v-if="showEdits" style="position:absolute;top: 0px; right: 0px;height:100%;"
              v-on="editTMP.isNew ? on : null"
            >
              <v-btn
                class="mnuEdit"
                fab small
                :dark="!editTMP.isNew"
                :disabled="editTMP.isNew"
                color="#0000004D"
                style="margin-top: 10px;margin-right: 15px;"
                @click.stop="onEdit(editTMP)"
              >
                <v-icon :dark="!editTMP.isNew" style="font-size: 16px;">mdi-pencil</v-icon>
              </v-btn>
            </div>
          </template>
          <span>{{ $t('menus.info.saveBeforeEdit') }}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <!-- <v-layout
      wrap
      align-center
      justify-center
      style="position: relative; height: 100%; width: 100%;"
    >
      <v-flex
        xs4
      >
      </v-flex>
      <v-flex xs4 />
      <v-flex xs4>
        <div class="text-right">
          <v-btn class="mnuEdit" fab dark small :color="editTMP.isSecundary ? 'purple' : 'secundary'"
          style="margin: 15px;"
            @click.stop="onEdit(menu)"
          >
            <v-icon dark>mdi-file-document-box-plus-outline</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout> -->
      <!-- <v-icon style="margin-right: 10px;"></v-icon>
      <v-spacer />
      <v-toolbar-title>{{ editTMP.Name.es }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        class="mx-2" fab dark small 
        :color="enterpriseColor"
        @click.stop="handleAdd"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import CustomColorPicker from '@/components/CustomColorPicker'
  export default {
    components: {
      CustomColorPicker
    },
    props: {
      editTMP: {
        type: Object,
        require: true
      },
      showEdits: {
        type: Boolean,
        required: false,
        default: false
      },
      onEdit: {
        type: Function,
        required: false,
        default: null
      }
    },
    data: () => ({
      edittmpName: '',
      // customMenuColor: null,
    }),
    computed: {
      ...mapState('app',['locale', 'withGradient', 'withGradientSubmenu', 'BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont', 'FontSecundary', 'FontSizeSecundary', 'Font', 'FontSize', ]),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseName () {
        return this.$store.state.app.enterpriseName
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      /*
      edittmpName () {
        return utils.getTranslation(this.editTMP.Name, this.locale)
      },
      */
    },
    watch: {
      locale () {
        this.prepareName()
      },
      editTMP () {
        this.prepareName()
      },
    },
    mounted () {
      // if (!this.$store.state.app.editTMP.CustomMenuColor) {
      //   this.customMenuColor = this.$store.state.app.editTMP.CustomMenuColor ? this.$store.state.app.editTMP.CustomMenuColor : 
      //                           this.editTMP.isSecundary ? this.BGColorSecundary : this.BGColor
      // }
      this.prepareName()
    },
    methods: {
      prepareName () {
        if (this.editTMP && this.editTMP.Name)
          this.edittmpName = utils.getTranslation(this.editTMP.Name, this.locale ? this.locale : 'es')
      },
      // handleChangeColor (value) {
      //   this.customMenuColor = value
      //   this.$store.state.app.editTMP.CustomMenuColor = value
      // }
    }
  }
</script>
<style lang="scss">
  .mnuEdit {
    min-height: 20px;
    height: 25px !important;
    width: 25px !important;
  }
</style>
